import { LegAWSInt } from '@app/interfaces/reservation-aws.interface';

/**
 * Estatus que el kiosko usa por segmento (windowSegmentStatus: CKI, MYB, CLOSED, IN_FLIGHT, USED...)
 * en una sola cadena para New Relic, ej. "CUU-MEX AM139 CLOSED | MEX-TIJ AM188 CKI".
 * Incluye todos los tramos de la reserva en el orden en que llegan.
 */
export function buildSegmentsStatus(legs: LegAWSInt[]): string {
  return (legs ?? [])
    .flatMap((leg) => leg?.segments ?? [])
    .map((segment) => {
      const route = `${segment?.departureAirport ?? ''}-${segment?.arrivalAirport ?? ''}`;
      const flight = `${segment?.operatingCarrier ?? ''}${segment?.operatingFlightCode ?? ''}`;
      return `${route} ${flight} ${segment?.windowSegmentStatus || 'SIN_ESTATUS'}`;
    })
    .join(' | ');
}
